export const DEFAULT_COMPONENT_PADDING = { xs: 8, l: 12, xl: 14 };
